/* Mamavea - product page "Autumn Sale" behaviour (pairs with mamavea-pdp-sale.css)
   1. Keeps the star/review line above the product title.
   2. Tags the two variant pickers so CSS can show colour first, size second.
   3. Moves the Kiwi "Size Chart" link onto the "Select size" line (right side).
   4. Adds "| price  old price" to the Add to Cart button and keeps it
      in sync when the shopper changes variant.
   5. Rewords "Ships by" to "Shipped by". */
(function () {
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function moveStars() {
    var meta = document.querySelector('.product-single__meta');
    if (!meta) return;
    var stars = meta.querySelector('.product-review-line');
    var title = meta.querySelector('.product-single__title');
    if (!stars || !title || title.previousElementSibling === stars) return;
    title.parentNode.insertBefore(stars, title);
  }

  function tagVariants() {
    var w = document.querySelectorAll('.product-single__meta .variant-wrapper');
    if (w[0] && !w[0].classList.contains('mv-vw-1')) w[0].classList.add('mv-vw-1');
    if (w[1] && !w[1].classList.contains('mv-vw-2')) w[1].classList.add('mv-vw-2');
  }

  function moveSizeChart() {
    var meta = document.querySelector('.product-single__meta');
    if (!meta) return;
    var chart = meta.querySelector('.ks-container-app-block');
    if (!chart) return;
    var block = chart.closest('.shopify-block') || chart;
    var wrappers = meta.querySelectorAll('.variant-wrapper');
    var sizeWrap = meta.querySelector('.variant-wrapper.mv-vw-2') || (wrappers.length === 1 ? wrappers[0] : null);
    if (!sizeWrap || block.parentNode === sizeWrap) return;
    if (!block.classList.contains('mv-sizechart')) block.classList.add('mv-sizechart');
    sizeWrap.classList.add('mv-has-sizechart');
    sizeWrap.appendChild(block);
  }

  function updateButtons() {
    var meta = document.querySelector('.product-single__meta');
    if (!meta) return;
    var priceEl = meta.querySelector('[data-product-price]') || meta.querySelector('.product__price');
    var compareEl = meta.querySelector('[data-compare-price]') || meta.querySelector('.product__price--compare');
    var price = txt(priceEl);
    var compare = (compareEl && !compareEl.closest('.hide')) ? txt(compareEl) : '';
    if (compare === price) compare = '';
    document.querySelectorAll('.product-single__form .add-to-cart').forEach(function (btn) {
      var extra = btn.querySelector('.mv-atc-extra');
      if (!extra) {
        extra = document.createElement('span');
        extra.className = 'mv-atc-extra';
        btn.appendChild(extra);
      }
      var html = price ? ' | <span class="mv-atc-price"></span>' + (compare ? '<span class="mv-atc-compare"></span>' : '') : '';
      if (extra.dataset.key === price + '|' + compare) return;
      extra.dataset.key = price + '|' + compare;
      extra.innerHTML = html;
      if (price) extra.querySelector('.mv-atc-price').textContent = price;
      if (compare) extra.querySelector('.mv-atc-compare').textContent = compare;
    });
  }

  function reword() {
    document.querySelectorAll('.stock-ship-item span').forEach(function (s) {
      if (s.firstChild && s.firstChild.nodeType === 3 && /^Ships by:/.test(s.firstChild.nodeValue)) {
        s.firstChild.nodeValue = s.firstChild.nodeValue.replace('Ships by:', 'Shipped by:');
      }
    });
  }

  var queued = false;
  function run() { queued = false; moveStars(); tagVariants(); moveSizeChart(); updateButtons(); reword(); }
  function schedule() { if (!queued) { queued = true; setTimeout(run, 30); } }

  function init() {
    run();
    var meta = document.querySelector('.product-single__meta');
    if (meta && window.MutationObserver) {
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) {
          var t = m[i].target;
          if (t.nodeType === 3) t = t.parentNode;
          if (t && t.closest && t.closest('.mv-atc-extra')) continue;
          schedule(); return;
        }
      }).observe(meta, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    }
    setTimeout(run, 500); setTimeout(run, 1500); setTimeout(run, 3000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
